class BookSection extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initSwiper();
    }

    initSwiper() {
        const swiper = new Swiper('.book__swiper', {
            slidesPerView: "auto",
            effect: 'fade',
            loop: true,
            allowTouchMove: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }
}

customElements.define('book-section', BookSection);